import * as React from 'react'
import classnames from 'classnames'
import cls from './SocialHeader.module.scss'
import { constants } from 'helpers'
import UikTabItem from '../UikTabItem'
import UikTabContainer from '../UikTabContainer'
import UikWidget from '../UikWidget'

const {
  EVENT_CONSTANTS: { PLACEHOLDER_IMG },
  HOST_PORTAL_TABS: { TICKET_SALES },
} = constants

const UikSocialHeader = ({
  className,
  Component,
  imgUrl,
  avatar,
  name,
  selectedTabTitle,
  selectTabTitle,
  hidesEditTab,
  removeTabs,
  ...rest
}) => {
  const tabs = [
    {
      text: TICKET_SALES,
    },
  ]

  return (
    <React.Fragment>
      <div className={cls.cover} style={{ backgroundImage: `url(${imgUrl || PLACEHOLDER_IMG})` }}>
        <h1 className={cls.name}>{name}</h1>
      </div>
      {!removeTabs && (
        <div className={cls.content}>
          <div className={cls.tabWrapper}>
            <UikTabContainer>
              {tabs.map(item => (
                <UikTabItem
                  onClick={() => selectTabTitle(item.text)}
                  key={item.text}
                  className={classnames(
                    {
                      active: item.text === selectedTabTitle,
                      [cls.alignRight]: item.align === 'right',
                    },
                    cls.shortItem
                  )}
                  {...item}
                />
              ))}
            </UikTabContainer>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

UikSocialHeader.defaultProps = {
  className: null,
  Component: UikWidget,
  imgUrl: null,
  selectedTabTitle: 'Guestlist',
  hidesEditTab: false,
}

export default UikSocialHeader
